import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'swodocEditNodeFilter',
  pure: false,
})
export class SwodocEditNodeFilterPipe implements PipeTransform {
  transform(items: any[]): any {
    if (!items || !items.length) {
      return [];
    }
    return items.filter(f => f.nodeType_Id !== 'condition' && !f.inactive);
  }
}
